import { Slide } from "@jelly/lesson";
import config from "appConfig";

import { task as task07 } from "../../../../../task/course-05/lesson-06/task-07";

const task: Slide = {
  titleHtml:
    "Please drag and drop the red tiles onto the green tiles to put the sound files in the<br>correct order (from closer to further from the source).",
  description: "Drag and drop elements.",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [1.5, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/06/task/task-7.svg`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task07.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
